/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Notifications_Job_CompletionInputs */

const en_options_notifications_job_completion = /** @type {(inputs: Options_Notifications_Job_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Completion Report`)
};

const fr_options_notifications_job_completion = /** @type {(inputs: Options_Notifications_Job_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapport de fin de tâche`)
};

const de_options_notifications_job_completion = /** @type {(inputs: Options_Notifications_Job_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbeitsabschlussbericht`)
};

const it_options_notifications_job_completion = /** @type {(inputs: Options_Notifications_Job_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapporto di completamento del lavoro`)
};

const ru_options_notifications_job_completion = /** @type {(inputs: Options_Notifications_Job_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отчет о завершении работ`)
};

const es_options_notifications_job_completion = /** @type {(inputs: Options_Notifications_Job_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe de finalización del trabajo`)
};

const zh_cn2_options_notifications_job_completion = /** @type {(inputs: Options_Notifications_Job_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工作完成报告`)
};

const ja_options_notifications_job_completion = /** @type {(inputs: Options_Notifications_Job_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ジョブ完了レポート`)
};

const hi_options_notifications_job_completion = /** @type {(inputs: Options_Notifications_Job_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्य पूर्णता रिपोर्ट`)
};

const pt_pt2_options_notifications_job_completion = /** @type {(inputs: Options_Notifications_Job_CompletionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relatório de Conclusão de Trabalho`)
};

/**
* | output |
* | --- |
* | "Job Completion Report" |
*
* @param {Options_Notifications_Job_CompletionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_notifications_job_completion = /** @type {((inputs?: Options_Notifications_Job_CompletionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Notifications_Job_CompletionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_notifications_job_completion(inputs)
	if (locale === "de") return de_options_notifications_job_completion(inputs)
	if (locale === "it") return it_options_notifications_job_completion(inputs)
	if (locale === "ru") return ru_options_notifications_job_completion(inputs)
	if (locale === "es") return es_options_notifications_job_completion(inputs)
	if (locale === "zh-CN") return zh_cn2_options_notifications_job_completion(inputs)
	if (locale === "ja") return ja_options_notifications_job_completion(inputs)
	if (locale === "hi") return hi_options_notifications_job_completion(inputs)
	if (locale === "pt-PT") return pt_pt2_options_notifications_job_completion(inputs)
	return en_options_notifications_job_completion(inputs)
});